import { render, staticRenderFns } from "./AssetsCheck.vue?vue&type=template&id=effaf980&scoped=true"
import script from "./AssetsCheck.vue?vue&type=script&lang=js"
export * from "./AssetsCheck.vue?vue&type=script&lang=js"
import style0 from "./AssetsCheck.vue?vue&type=style&index=0&id=effaf980&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effaf980",
  null
  
)

export default component.exports